import { useCallback } from 'react';

import { Box, Button, Divider, Grid, Group, Text } from '@mantine/core';
import { closeAllModals, openConfirmModal } from '@mantine/modals';
import { showNotification } from '@mantine/notifications';
import { IconTrash, IconX } from '@tabler/icons-react';
import { dateToDateHourString } from '@utils/date';

import { Contact } from '@interfaces/contact.interface';

import { useDeleteContactMutation } from '@api/contacts.api';
import { isApiError } from '@api/index';

import SingleInfoDetail from '@components/ProductStat';

interface ContactDetailProps {
  data: Contact;
}
export const DETAIL_CONTACT_MODAL_ID = 'contact-detail-modal';

export default function ContactDetail({ data }: ContactDetailProps) {
  // ==========================================================================
  // General
  // ==========================================================================

  // ==========================================================================
  // State
  // ==========================================================================

  // ==========================================================================
  // Api
  // ==========================================================================

  const [deleteContact, { isLoading: isLoadingDeleteContact }] =
    useDeleteContactMutation();
  // ==========================================================================
  // Form
  // ==========================================================================

  // ==========================================================================
  // Handlers
  // ==========================================================================
  const handleDeleteContactClick = useCallback((value: Contact) => {
    openConfirmModal({
      title: 'Elimina contatto',
      children: (
        <span>
          Stai per eliminare il contatto{' '}
          <i>
            {value.firstName} {value.lastName}
          </i>
          . L'operazione non è reversibile. Continuare?
        </span>
      ),

      confirmProps: { color: 'red' },
      labels: { confirm: 'Conferma', cancel: 'Annulla' },
      onConfirm: async () => {
        try {
          await deleteContact(value.id).unwrap();
          closeAllModals();

          showNotification({
            color: 'red',
            title: 'Contatto eliminato',
            message: 'Contatto eliminato con successo',
          });
        } catch (e) {
          if (isApiError(e)) {
            showNotification({
              title: 'Errore',
              message: e.data.message,
              color: 'red',
              icon: <IconX />,
            });
          } else {
            showNotification({
              title: 'Errore',
              message: 'Errore sconosciuto',
              color: 'red',
              icon: <IconX />,
            });
            console.error(e);
          }
        }
      },
    });
  }, []);
  // ==========================================================================
  // Render
  // ==========================================================================
  return (
    <Box>
      <Group gap="xl" align="start">
        <Grid w="100%">
          <Grid.Col span={12} pb="0">
            <Divider
              label={
                <Text fw={500} fz="sm">
                  Informazioni contatto
                </Text>
              }
              labelPosition="left"
              w="100%"
            />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6 }}>
            <SingleInfoDetail label="Nome" value={data.firstName} />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6 }}>
            <SingleInfoDetail label="Cognome" value={data.lastName} />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6 }}>
            <SingleInfoDetail label="Telefono" value={data.phone} />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6 }}>
            <SingleInfoDetail label="Città" value={data.city} />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 6 }}>
            <SingleInfoDetail label="Email" value={data.email} />
          </Grid.Col>
          {data.type === 'company' && (
            <Grid.Col span={{ xs: 12, sm: 6 }}>
              <SingleInfoDetail label="Nome azienda" value={data.companyName} />
            </Grid.Col>
          )}
          <Grid.Col span={12}>
            <Divider my="sm" />
            <Group justify="space-between" align="center">
              <div>
                <Text size="xs" c="dimmed">
                  Ultima modifica
                </Text>
                <Text size="sm">
                  {dateToDateHourString(new Date(data.updatedAt))}
                </Text>
              </div>
              <Button
                color="red"
                disabled={isLoadingDeleteContact}
                onClick={() => handleDeleteContactClick(data)}
                leftSection={<IconTrash />}
              >
                Elimina contatto
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </Group>
    </Box>
  );
}
